module.exports = __webpack_public_path__ + "img/stock4.efc7966f.png";